import { api } from '@/config'
import httpApi from '@/util/http-api'

export default {
  getJobs: () => { // will be deleted
    return httpApi.getDataViaApi(api.jobs + '/list')
  },
  getAvailableFilters: () => {
    return httpApi.getDataViaApi(api.jobs + '/available-filters')
  },
  getJobCount: (body) => {
    return httpApi.postDataViaApi(api.jobs + '/count', body)
  },
  searchJob: (body) => {
    return httpApi.postDataViaApi(api.jobs + '/search', body)
  },
  getJobDetail: (data) => {
    return httpApi.getDataViaApi(api.jobs + '/' + data.jobId)
  },
  uploadFile: (data) => {
    const formData = new FormData()
    formData.append('fileName', data.fileName)
    return httpApi.uploadFile(api.jobs + '/' + data.jobId + '/attachment', formData)
  },
  applyJob: (data) => {
    return httpApi.postDataViaApi(api.jobs + '/' + data.jobId + '/apply', data)
  },
  submitGeneralForm: (data) => {
    return httpApi.postDataViaApi(api.jobs + '/' + data.workflowDetails.jobId + '/apply-general-form', data)
  },
  getTracking: (applicationId, email) => {
    return httpApi.getDataViaApi(`${api.jobs}/tracking?applicationId=${applicationId}&email=${email}`)
  }
}
